import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CustomerConstants } from '../../Helpers/requests';
import {
  findGuid,
  filterMethod,
  snackMessage,
  validateEmptyMail,
  validateRequired,
} from '../../Helpers/helpers';
import { APIROOT } from '../../Helpers/configs';
import { GetAuth } from '../../Auth/AuthProvider';
import { FormCategory, FormHeadCategory } from '../shared/FormElements';
import {
  Card,
  Grid,
  Box,
  TextField,
  Typography,
  Button,
  Stack,
  Snackbar,
} from '@mui/material/';
import MuiAlert from '@mui/material/Alert';
import Autocomplete from '@mui/material/Autocomplete';
import './Customer.css';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant='filled' {...props} />;
});

export default function CustomerInfoCard(props) {
  const returnInfo = props.returnInfo;
  const [snackBarMessage, setSnackBarMessage] = useState('');

  // AutoSelect State
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedAMC, setSelectedAMC] = useState(null);

  const [categoriesData, setCategoriesData] = useState([]); //Constant - Categories List
  const [regionsData, setRegionsData] = useState([]); //Constant - Regions List
  const [asset_compData, setAsset_compData] = useState([]); //Constant - Asset Comp List
  const enqNotification = GetAuth().Notification; //Custom Hook - Returns a function which can be used to enque Notifications
  const logout = GetAuth().signOut; //Custom Hook - returns Signout function

  const [open, setOpen] = useState(false);
  const [forceUpdate, setForceUpdate] = useState(1);

  const [customerAddress, setCustomerAddress] = useState(
    props.customerData.address
  );
  const [customerCategory, setCustomerCategory] = useState(
    props.customerData.category
  );
  const [customerBranchCode, setCustomerBranchCode] = useState(
    props.customerData.branchcode
  );
  const [customerBranchName, setCustomerBranchName] = useState(
    props.customerData.name
  );
  const [customerRegion, setCustomerRegion] = useState(
    props.customerData.region
  );

  //DIV MAN DETAILS
  const [customerDivManager, setCustomerDivManager] = useState(
    props.customerData.div_man_contact_name || ''
  );
  const [customerDivManagerNumber, setCustomerDivManagerNumber] = useState(
    props.customerData.div_man_contact_num || ''
  );
  const [customerDivManagerEmail, setCustomerDivManagerEmail] = useState(
    props.customerData.div_man_contact_email || ''
  );

  //DEP DIV MAN DETAILS
  const [customerDepDivManager, setCustomerDepDivManager] = useState(
    props.customerData.deputy_div_man_name || ''
  );
  const [customerDepDivManagerNumber, setCustomerDepDivManagerNumber] =
    useState(props.customerData.deputy_div_man_num || '');

  const [customerDepDivManagerEmail, setCustomerDepDivManagerEmail] = useState(
    props.customerData.deputy_div_man_email || ''
  );

  //REG MAN DETAILS
  const [customerRegManager, setCustomerRegManager] = useState(
    props.customerData.region_man_name || ''
  );
  const [customerRegManagerNumber, setCustomerRegManagerNumber] = useState(
    props.customerData.region_man_num || ''
  );
  const [customerRegManagerEmail, setCustomerRegManagerEmail] = useState(
    props.customerData.region_man_email || ''
  );

  //STORE MAN DETAILS
  const [customerStoreManName, setCustomerStoreManName] = useState(
    props.customerData.store_man_name || ''
  );
  const [customerStoreManNumber, setCustomerStoreManNumber] = useState(
    props.customerData.store_man_num || ''
  );
  const [customerStoreManEmail, setCustomerStoreManEmail] = useState(
    props.customerData.store_man_email || ''
  );

  //TECH MAN DETAILS
  const [customerTechnicalManName, setCustomerTechnicalManName] = useState(
    props.customerData.technical_man_contact_name || ''
  );
  const [customerTechnicalManNum, setCustomerTechnicalManNum] = useState(
    props.customerData.technical_man_contact_num || ''
  );
  const [customerTechnicalManEmail, setCustomerTechnicalManEmail] = useState(
    props.customerData.technical_man_contact_email || ''
  );

  const [customerStoreTel, setCustomerStoreTel] = useState(
    props.customerData.store_tel
  );
  const [customerAssetManComp, setCustomerAssetManComp] = useState(
    props.customerData.asset_man_comp
  );

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const [uri, setUri] = useState(props.postUri);

  const trimSubmitForDataBlob = () => {
    let cust_Cat = customerCategory;
    let cust_branch = customerBranchName.replace(/\s+/g, ' ').trim();
    let cust_StoreManName = customerStoreManName.replace(/\s+/g, ' ').trim();
    let cust_StoreManNum = customerStoreManNumber.replace(/\s+/g, ' ').trim();
    let cust_StoreManEmail = customerStoreManEmail.replace(/\s+/g, ' ').trim();
    let cust_RegManName = customerRegManager.replace(/\s+/g, ' ').trim();
    let cust_RegManNum = customerRegManagerNumber.replace(/\s+/g, ' ').trim();
    let cust_RegManEmail = customerRegManagerEmail.replace(/\s+/g, ' ').trim();
    let cust_DepDivName = customerDepDivManager.replace(/\s+/g, ' ').trim();
    let cust_DepDivNum = customerDepDivManagerNumber
      .replace(/\s+/g, ' ')
      .trim();
    let cust_DepDivEmail = customerDepDivManagerEmail
      .replace(/\s+/g, ' ')
      .trim();
    let cust_DivManName = customerDivManager.replace(/\s+/g, '').trim();
    let cust_DivManNum = customerDivManagerNumber.replace(/ /g, ' ').trim();
    let cust_DivManEmail = customerDivManagerEmail.replace(/ /g, ' ').trim();
    let cust_TechManName = customerTechnicalManName.replace(/\s+/g, ' ').trim();
    let cust_TechManNum = customerTechnicalManNum.replace(/ /g, '').trim();
    let cust_TechManEmail = customerTechnicalManEmail.replace(/ /g, '').trim();
    let cust_Region = customerRegion;
    let cust_Add = customerAddress.replace(/\s+/g, ' ').trim();
    let cust_BrachCode = customerBranchCode.replace(/\s+/g, ' ').trim();
    let cust_StoreTel = customerStoreTel.replace(/\s+/g, ' ').trim();
    let cust_AssManComp = customerAssetManComp;

    const CustomerDataBlob = {
      customer: {
        category: cust_Cat,
        name: cust_branch,
        store_man_name: cust_StoreManName,
        store_man_num: cust_StoreManNum,
        store_man_email: cust_StoreManEmail,
        region_man_name: cust_RegManName,
        region_man_num: cust_RegManNum,
        region_man_email: cust_RegManEmail,
        deputy_div_man_name: cust_DepDivName,
        deputy_div_man_num: cust_DepDivNum,
        deputy_div_man_email: cust_DepDivEmail,
        div_man_contact_name: cust_DivManName,
        div_man_contact_num: cust_DivManNum,
        div_man_contact_email: cust_DivManEmail,
        technical_man_contact_name: cust_TechManName,
        technical_man_contact_num: cust_TechManNum,
        technical_man_contact_email: cust_TechManEmail,
        region: cust_Region,
        address: cust_Add,
        branchcode: cust_BrachCode,
        store_tel: cust_StoreTel,
        asset_man_comp: cust_AssManComp,
      },
    };
    return CustomerDataBlob;
  };

  const validateForSubmit = () => {
    // if (validateEmptyMail(customerDivManagerEmail)) {
    //   snackMessage('email', 'Divisional Manager', setSnackBarMessage);
    //   setOpen(true);
    // } else if (validateEmptyMail(customerDepDivManagerEmail)) {
    //   snackMessage('email', 'Deputy Divisional', setSnackBarMessage);
    //   setOpen(true);
    // } else if (validateEmptyMail(customerRegManagerEmail)) {
    //   snackMessage('email', 'Regional Manager', setSnackBarMessage);
    //   setOpen(true);
    // } else if (validateEmptyMail(customerStoreManEmail)) {
    //   snackMessage('email', 'Store Manager', setSnackBarMessage);
    //   setOpen(true);
    // } else if (validateEmptyMail(customerTechnicalManEmail)) {
    //   snackMessage('email', 'Technical Manager', setSnackBarMessage);
    //   setOpen(true);
    // } else
    if (validateRequired(customerAddress)) {
      snackMessage('required', 'Customer Address', setSnackBarMessage);
      setOpen(true);
    } else if (validateRequired(customerBranchCode)) {
      snackMessage('required', 'Customer Branch Code', setSnackBarMessage);
      setOpen(true);
    } else if (validateRequired(customerStoreTel)) {
      snackMessage('required', 'Customer Telephone Number', setSnackBarMessage);
      //   setOpen(true);
      // } else if (validateRequired(customerStoreManName)) {
      //   snackMessage('required', 'Store Manager Name', setSnackBarMessage);
      //   setOpen(true);
      // } else if (validateRequired(customerStoreManNumber)) {
      //   snackMessage('required', 'Store Manager Number', setSnackBarMessage);
      //   setOpen(true);
    } else {
      customerEndPoint();
    }
  };

  const customerEndPoint = () => {
    const CustomerDataBlob = { ...trimSubmitForDataBlob() };
    //Get JWT from storage
    let JWT = localStorage.getItem('JWT_Key');
    //Set default Headers
    let headers = {
      'content-type': 'application/JSON',
    };
    //Set JWT in header if available
    if (JWT) {
      headers['x-api-key'] = JWT;
    }
    let body = {};
    body = CustomerDataBlob;
    const request = new Request(`${APIROOT}${uri}`, {
      method: 'post',
      headers,
      body: JSON.stringify(body),
    });
    fetch(request)
      .then((response) => {
        if (response.status === 200) {
          return response.text();
        } else {
          throw new Error(`Failed to save customer`);
        }
      })
      .then((data) => {
        let parsed = JSON.parse(data);
        if (parsed.success === true) {
          setForceUpdate((val) => val + 1);
          //Update JWT if required
          if (parsed.JWT) {
            localStorage.setItem('JWT_Key', parsed.JWT);
          }
          navigateBack(`/customer`, {
            replace: true,
            state: returnInfo,
          });
        } else {
          //Force logout
          if (parsed.message === 'Please login') {
            logout(() => {
              enqNotification('Session Expired', 'warning');
            });
          } else {
            enqNotification(parsed.message, 'error');
          }
        }
      })
      .catch((error) => {
        enqNotification(
          typeof error == 'string' ? error : 'Connection Error',
          'error'
        );
      });
  };

  // HANDLE REGION
  useEffect(() => {
    let RegionObj = findGuid(props.customerData.region, regionsData);
    setSelectedRegion(RegionObj);
  }, [regionsData]);
  const filterRegionsOptions = filterMethod;
  const handleCustomerRegion = (event, newValue) => {
    setSelectedRegion(newValue);
    setCustomerRegion(newValue.id);
  };

  // HANDLE CATEGORY
  useEffect(() => {
    let CategoryObj = findGuid(props.customerData.category, categoriesData);
    setSelectedCategory(CategoryObj);
  }, [categoriesData]);
  const filterCategoriesOptions = filterMethod;
  const handleCustomerCategory = (event, newValue) => {
    setSelectedCategory(newValue);
    setCustomerCategory(newValue.id);
  };

  // HANDLE ASSET MAN COMP
  useEffect(() => {
    let AMCObj = findGuid(props.customerData.asset_man_comp, asset_compData);
    setSelectedAMC(AMCObj);
  }, [asset_compData]);
  const filterAMCOptions = filterMethod;
  const handleCustomerAMC = (event, newValue) => {
    setSelectedAMC(newValue);
    setCustomerAssetManComp(newValue.id);
  };

  // HANDLE CHANGE EVENTS
  const handleChange = (event) => {
    let checkEvent = event.target.name;
    switch (checkEvent) {
      case 'address':
        setCustomerAddress(event.target.value);
        break;
      case 'branchcode':
        setCustomerBranchCode(event.target.value);
        break;
      case 'name':
        setCustomerBranchName(event.target.value);
        break;
      case 'div_man_name':
        setCustomerDivManager(event.target.value);
        break;
      case 'div_man_num':
        setCustomerDivManagerNumber(event.target.value.replace(/\D/g, ''));
        break;
      case 'div_man_email':
        setCustomerDivManagerEmail(event.target.value);
        break;
      case 'deputy_div_man_name':
        setCustomerDepDivManager(event.target.value);
        break;
      case 'deputy_div_man_number':
        setCustomerDepDivManagerNumber(event.target.value.replace(/\D/g, ''));
        break;
      case 'deputy_div_man_email':
        setCustomerDepDivManagerEmail(event.target.value);
        break;
      case 'regional_man_name':
        setCustomerRegManager(event.target.value);
        break;
      case 'regional_man_number':
        setCustomerRegManagerNumber(event.target.value.replace(/\D/g, ''));
        break;
      case 'regional_man_email':
        setCustomerRegManagerEmail(event.target.value);
        break;
      case 'store_man_name':
        setCustomerStoreManName(event.target.value);
        break;
      case 'store_man_contact':
        setCustomerStoreManNumber(event.target.value.replace(/\D/g, ''));
        break;
      case 'store_man_email':
        setCustomerStoreManEmail(event.target.value);
        break;
      case 'technical_man_name':
        setCustomerTechnicalManName(event.target.value);
        break;
      case 'technical_man_number':
        setCustomerTechnicalManNum(event.target.value.replace(/\D/g, ''));
        break;
      case 'technical_man_email':
        setCustomerTechnicalManEmail(event.target.value);
        break;
      case 'store_tel':
        setCustomerStoreTel(event.target.value.replace(/\D/g, ''));
        break;
      default:
    }
  };

  const navigateBack = useNavigate();
  //Update Table when page,number of rows (pageSize), sort & filter models or force update (updateData) changes
  useEffect(() => {
    CustomerConstants({
      resource: `/api/constants/customer`,
      setCategoriesFunc: setCategoriesData,
      setRegionsFunc: setRegionsData,
      setAsset_compFunc: setAsset_compData,
      // setLoadingFunc: setLoading,
      showNotification: enqNotification,
      logout,
    });
  }, [enqNotification, logout]);

  const singleInputRowHeight = 40;

  return (
    <Box sx={{ minWidth: '100%', margin: 0 }}>
      <Grid
        container
        rowGap={1}
        // columnGap={1}
        rowSpacing={1}
        columnSpacing={{ xs: 1, sm: 1, md: 1 }}
        style={{
          // background: '#84a1bc91',
          background: 'rgb(235, 237, 248)',
          borderRadius: 5,
          padding: '5px 20px 5px 5px',
          // minHeight: '85vh',
          margin: '-6px 0',
        }}
      >
        <Grid item xs={12} md={12}>
          <Typography variant='h5' sx={{ height: singleInputRowHeight }}>
            Customer Detail
          </Typography>
        </Grid>

        <Grid item xs={12} md={12}>
          <Card sx={{ boxShadow: 'none', border: 'none', background: 'none' }}>
            <Box sx={{ width: '100%' }}>
              <Grid
                container
                rowSpacing={0}
                columnSpacing={{ xs: 2 }}
                rowGap={1}
                columnGap={0}
                style={{
                  // background: 'rgba(0,120,200,0.2)',
                  padding: '15px',
                  paddingTop: 0,
                }}
              >
                <Grid item xs={12} md={12}>
                  <FormHeadCategory
                    title='Store Information:'
                    style={{ fontSize: '1.2em !important' }}
                  />
                </Grid>
                <Grid item xs={12} md={1}>
                  <FormCategory title='Customer Name:' />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    sx={{ width: '100%', background: '#ffffff' }}
                    key='name'
                    name='name'
                    error={
                      customerBranchName === '' ||
                      customerBranchName === null ||
                      customerBranchName === undefined
                        ? true
                        : false
                    }
                    label={
                      customerBranchName === '' ||
                      customerBranchName === null ||
                      customerBranchName === undefined
                        ? 'required'
                        : ''
                    }
                    id='storeNameInput'
                    defaultValue={customerBranchName}
                    // default={customerBranchName}
                    onChange={handleChange}
                    variant='standard'
                    rows={1}
                  />
                </Grid>
                <Grid item xs={12} md={1}>
                  <FormCategory title='Store Phone Nr:' />
                </Grid>
                <Grid item xs={12} md={3} height={1}>
                  <TextField
                    name='store_tel'
                    key='store_tel'
                    error={
                      customerStoreTel === '' ||
                      customerStoreTel === null ||
                      customerStoreTel === undefined
                        ? true
                        : false
                    }
                    label={
                      customerStoreTel === '' ||
                      customerStoreTel === null ||
                      customerStoreTel === undefined
                        ? 'required'
                        : ''
                    }
                    sx={{ width: '100%', background: '#ffffff' }}
                    id='storeTelNrInput'
                    variant='standard'
                    rows={1}
                    defaultValue={customerStoreTel}
                    // value={customerStoreTel}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} md={1}>
                  <FormCategory title='Branch Code:' />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    sx={{
                      width: '100%',
                      background: '#ffffff',
                    }}
                    key='branchcode'
                    name='branchcode'
                    error={
                      customerBranchCode === '' ||
                      customerBranchCode === null ||
                      customerBranchCode === undefined
                        ? true
                        : false
                    }
                    label={
                      customerBranchCode === '' ||
                      customerBranchCode === null ||
                      customerBranchCode === undefined
                        ? 'required'
                        : ''
                    }
                    id='branchCodeInput'
                    defaultValue={customerBranchCode}
                    default={customerBranchCode}
                    onChange={handleChange}
                    variant='standard'
                    inputProps={{ maxLength: 6, minLength: 6 }}
                    rows={1}
                  />
                </Grid>
                <Grid item xs={12} md={1}>
                  <FormCategory title='Region:' />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Autocomplete
                    sx={{
                      width: '100%',
                      background: '#fff',
                      padding: 0,
                    }}
                    name='region'
                    key='region'
                    id='region'
                    variant='standard'
                    size='small'
                    value={selectedRegion}
                    onChange={handleCustomerRegion}
                    disablePortal
                    options={regionsData}
                    filterOptions={filterRegionsOptions}
                    getOptionLabel={(option) => option.name || ''}
                    renderInput={(params) => <TextField {...params} />}
                    isOptionEqualToValue={(option, value) => {
                      return option.id === value.id ? true : false;
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={1}>
                  <FormCategory title='Category:' />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Autocomplete
                    sx={{
                      width: '100%',
                      background: '#fff',
                      padding: 0,
                    }}
                    name='category'
                    key='category'
                    id='category'
                    variant='standard'
                    size='small'
                    value={selectedCategory}
                    onChange={handleCustomerCategory}
                    disablePortal
                    options={categoriesData}
                    filterOptions={filterCategoriesOptions}
                    getOptionLabel={(option) => option.name || ''}
                    renderInput={(params) => <TextField {...params} />}
                    isOptionEqualToValue={(option, value) => {
                      return option.id === value.id ? true : false;
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={1}>
                  <FormCategory title='Asset Man Comp:' />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Autocomplete
                    sx={{
                      width: '100%',
                      background: '#fff',
                      padding: 0,
                    }}
                    name='asset_man_comp'
                    key='asset_man_comp'
                    id='asset_man_comp'
                    variant='standard'
                    size='small'
                    value={selectedAMC}
                    onChange={handleCustomerAMC}
                    disablePortal
                    options={asset_compData}
                    filterOptions={filterAMCOptions}
                    getOptionLabel={(option) => option.name || ''}
                    renderInput={(params) => <TextField {...params} />}
                    isOptionEqualToValue={(option, value) => {
                      return option.id === value.id ? true : false;
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={1}>
                  <FormCategory title='Address:' />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    sx={{
                      width: '100%',
                      background: '#ffffff',
                      height: '125px',
                      borderRadius: 0,
                    }}
                    key='address'
                    name='address'
                    error={
                      customerAddress === '' ||
                      customerAddress === null ||
                      customerAddress === undefined
                        ? true
                        : false
                    }
                    label={
                      customerAddress === '' ||
                      customerAddress === null ||
                      customerAddress === undefined
                        ? 'required'
                        : ''
                    }
                    id='addressInput'
                    defaultValue={customerAddress}
                    // value={customerAddress}
                    onChange={handleChange}
                    rows={4}
                    multiline={true}
                  />
                </Grid>
              </Grid>
            </Box>
          </Card>
        </Grid>
        <Grid
          item
          xs={12}
          md={12}
          // sx={{ border: '1px solid black', borderRadius: 2 }}
        >
          <Card sx={{ boxShadow: 'none', border: 'none', background: 'none' }}>
            <Box sx={{ width: '100%' }}>
              <Grid
                container
                rowSpacing={0}
                columnSpacing={{ xs: 2 }}
                rowGap={1}
                style={{
                  // background: 'rgba(0,120,200,0.2)',
                  padding: '15px',
                  paddingTop: 0,
                }}
              >
                <Grid item xs={12} md={12}>
                  <FormHeadCategory title='Divisional Manager:' />
                </Grid>
                <Grid item xs={12} md={1}>
                  <FormCategory title='Name:' />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    name='div_man_name'
                    key='div_man_name'
                    sx={{ width: '100%', background: '#ffffff' }}
                    id='divManagerInput'
                    variant='standard'
                    rows={1}
                    defaultValue={customerDivManager}
                    // value={customerDivManager}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} md={1}>
                  <FormCategory title='Number:' />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    name='div_man_num'
                    key='div_man_num'
                    sx={{ width: '100%', background: '#ffffff' }}
                    id='divManContactNrInput'
                    variant='standard'
                    rows={1}
                    defaultValue={customerDivManagerNumber}
                    // value={customerDivManagerNumber}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} md={1}>
                  <FormCategory title='Email:' />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    type='email'
                    name='div_man_email'
                    key='div_man_email'
                    sx={{ width: '100%', background: '#ffffff' }}
                    id='divManEmailInput'
                    variant='standard'
                    rows={1}
                    defaultValue={customerDivManagerEmail}
                    // value={customerDivManagerEmail}
                    onChange={handleChange}
                  />
                </Grid>
              </Grid>

              <Grid
                container
                rowSpacing={0}
                columnSpacing={{ xs: 2 }}
                rowGap={1}
                xs={{ padding: '25px' }}
                style={{
                  // background: 'rgba(0,120,120,0.2)',
                  padding: '15px',
                  paddingTop: 0,
                }}
              >
                <Grid item xs={12} md={12}>
                  <FormHeadCategory title='Deputy Devisional:' />
                </Grid>
                <Grid item xs={12} md={1}>
                  <FormCategory title='Name:' />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    name='deputy_div_man_name'
                    key='deputy_div_man_name'
                    sx={{ width: '100%', background: '#ffffff' }}
                    id='deputyDivisionalInput'
                    variant='standard'
                    rows={1}
                    defaultValue={customerDepDivManager}
                    // value={customerDepDivManager}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} md={1}>
                  <FormCategory title='Number:' />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    name='deputy_div_man_number'
                    key='deputy_div_man_number'
                    sx={{ width: '100%', background: '#ffffff' }}
                    id='deputyDivContactNrInput'
                    variant='standard'
                    rows={1}
                    defaultValue={customerDepDivManagerNumber}
                    // value={customerDepDivManagerNumber}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} md={1}>
                  <FormCategory title='Email:' />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    name='deputy_div_man_email'
                    key='deputy_div_man_email'
                    sx={{ width: '100%', background: '#ffffff' }}
                    id='deputyDivEmailInput'
                    variant='standard'
                    rows={1}
                    defaultValue={customerDepDivManagerEmail}
                    // value={customerDepDivManagerEmail}
                    onChange={handleChange}
                  />
                </Grid>
              </Grid>

              <Grid
                container
                rowSpacing={0}
                columnSpacing={{ xs: 2 }}
                rowGap={1}
                style={{
                  // background: 'rgba(0,120,200,0.2)',
                  padding: '15px',
                  paddingTop: 0,
                }}
              >
                <Grid item xs={12} md={12}>
                  <FormHeadCategory title='Regional Manager:' />
                </Grid>
                <Grid item xs={12} md={1}>
                  <FormCategory title='Name:' />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    name='regional_man_name'
                    key='regional_man_name'
                    sx={{ width: '100%', background: '#ffffff' }}
                    id='regionalManagerInput'
                    variant='standard'
                    rows={1}
                    defaultValue={customerRegManager}
                    // value={customerRegManager}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} md={1}>
                  <FormCategory title='Number:' />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    name='regional_man_number'
                    key='regional_man_number'
                    sx={{ width: '100%', background: '#ffffff' }}
                    id='regionalManContactInput'
                    variant='standard'
                    rows={1}
                    defaultValue={customerRegManagerNumber}
                    // value={customerRegManagerNumber}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} md={1}>
                  <FormCategory title='Email:' />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    name='regional_man_email'
                    key='regional_man_email'
                    sx={{ width: '100%', background: '#ffffff' }}
                    id='regionalManEmailInput'
                    variant='standard'
                    rows={1}
                    defaultValue={customerRegManagerEmail}
                    // value={customerRegManagerEmail}
                    onChange={handleChange}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                rowSpacing={0}
                columnSpacing={{ xs: 2 }}
                rowGap={1}
                style={{
                  // background: 'rgba(0,120,120,0.2)',
                  padding: '15px',
                  paddingTop: 0,
                }}
              >
                <Grid item xs={12} md={12}>
                  <FormHeadCategory title='Store Manager:' />
                </Grid>
                <Grid item xs={12} md={1}>
                  <FormCategory title='Name:' />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    name='store_man_name'
                    key='store_man_name'
                    // error={customerStoreManName === '' ? true : false}
                    // label={customerStoreManName === '' ? 'required' : ''}
                    sx={{ width: '100%', background: '#ffffff' }}
                    id='storeManagerInput'
                    variant='standard'
                    rows={1}
                    defaultValue={customerStoreManName}
                    // value={customerStoreManName}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} md={1}>
                  <FormCategory title='Number:' />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    name='store_man_contact'
                    key='store_man_contact'
                    // error={
                    //   customerStoreManNumber === '' ||
                    //   customerStoreManNumber === undefined
                    //     ? true
                    //     : false
                    // }
                    // label={
                    //   customerStoreManNumber === '' ||
                    //   customerStoreManNumber === undefined
                    //     ? 'required'
                    //     : ''
                    // }
                    sx={{ width: '100%', background: '#ffffff' }}
                    id='storeManContactInput'
                    variant='standard'
                    rows={1}
                    defaultValue={customerStoreManNumber}
                    // value={customerStoreManNumber}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} md={1}>
                  <FormCategory title='Email:' />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    name='store_man_email'
                    key='store_man_email'
                    // error={
                    //   customerStoreManNumber === '' ||
                    //   customerStoreManNumber === undefined
                    //     ? true
                    //     : false
                    // }
                    // label={
                    //   customerStoreManNumber === '' ||
                    //   customerStoreManNumber === undefined
                    //     ? 'required'
                    //     : ''
                    // }
                    sx={{ width: '100%', background: '#ffffff' }}
                    id='storeManEmailInput'
                    variant='standard'
                    rows={1}
                    defaultValue={customerStoreManEmail}
                    // value={customerStoreManEmail}
                    onChange={handleChange}
                  />
                </Grid>
              </Grid>

              <Grid
                container
                rowSpacing={0}
                columnSpacing={{ xs: 2 }}
                rowGap={1}
                style={{
                  // background: 'rgba(0,120,200,0.2)',
                  padding: '15px',
                  paddingTop: 0,
                }}
              >
                <Grid item xs={12} md={12}>
                  <FormHeadCategory title='Technical Manager:' />
                </Grid>
                <Grid item xs={12} md={1}>
                  <FormCategory title='Name:' />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    name='technical_man_name'
                    key='technical_man_name'
                    // error={customerTechnicalManName === '' ? true : false}
                    // label={customerTechnicalManName === '' ? 'required' : ''}
                    sx={{ width: '100%', background: '#ffffff' }}
                    id='technicalMangerInput'
                    variant='standard'
                    rows={1}
                    defaultValue={customerTechnicalManName}
                    // value={customerTechnicalManName}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} md={1}>
                  <FormCategory title='Number:' />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    name='technical_man_number'
                    key='technical_man_number'
                    // error={customerTechnicalManNum === '' ? true : false}
                    // label={customerTechnicalManNum === '' ? 'required' : ''}
                    sx={{ width: '100%', background: '#ffffff' }}
                    id='technicalManContactInput'
                    variant='standard'
                    rows={1}
                    defaultValue={customerTechnicalManNum}
                    // value={customerTechnicalManNum}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} md={1}>
                  <FormCategory title='Email:' />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    name='technical_man_email'
                    key='technical_man_email'
                    // error={customerTechnicalManNum === '' ? true : false}
                    // label={customerTechnicalManNum === '' ? 'required' : ''}
                    sx={{ width: '100%', background: '#ffffff' }}
                    id='technicalManEmailInput'
                    type='email'
                    variant='standard'
                    rows={1}
                    defaultValue={customerTechnicalManEmail}
                    // value={customerTechnicalManEmail}
                    onChange={handleChange}
                  />
                </Grid>
              </Grid>
            </Box>
          </Card>
        </Grid>
        <Grid item xs={12} md={12}>
          <Card sx={{ background: 'none', border: 'none', boxShadow: 'none' }}>
            <Stack
              spacing={2}
              direction='row'
              sx={{ float: 'right', margin: '15px' }}
            >
              <Button
                variant='contained'
                onClick={() => {
                  validateForSubmit();
                }}
              >
                Save
              </Button>
              <Button
                variant='outlined'
                onClick={() => {
                  navigateBack(`/customer`, {
                    replace: true,
                    state: returnInfo,
                  });
                }}
              >
                Cancel
              </Button>
            </Stack>
          </Card>
        </Grid>
      </Grid>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity='error' sx={{ width: '100%' }}>
          {snackBarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
}
